import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getAssetFormConfig = () => {
  return {
    Title: {
      fieldId: 'Title',
      formLabel: t(`fields.Title`),
      columnHeader: t(`assets.columns.title`),
      allowAsConditionSource: true,
    },
    Description: {
      fieldId: 'Description',
      formLabel: t(`fields.Description`),
      columnHeader: t(`assets.columns.description`),
      allowTargetConditions: true,
      displayType: { displayType: 'textarea' },
    },
    Owners: {
      fieldId: 'Owners',
      formLabel: t(`fields.Owner`),
      columnHeader: t(`columns.owners`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
    },
    Contributors: {
      fieldId: 'Contributors',
      formLabel: t(`fields.Contributor`),
      columnHeader: t(`columns.contributors`),
      displayType: {
        displayType: 'users',
        multiple: true,
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    Status: {
      fieldId: 'Status',
      formLabel: t(`fields.Status`),
      columnHeader: t(`assets.columns.status`),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'asset_status' },
    },
    AssetType: {
      fieldId: 'AssetType',
      formLabel: t(`assets.fields.AssetType`),
      columnHeader: t(`assets.columns.assetType`),
      allowAsConditionSource: true,
    },
    SerialNumber: {
      fieldId: 'SerialNumber',
      formLabel: t(`assets.fields.SerialNumber`),
      columnHeader: t(`assets.columns.serialNumber`),
      allowAsConditionSource: true,
    },
    PurchaseDate: {
      fieldId: 'PurchaseDate',
      formLabel: t(`assets.fields.PurchaseDate`),
      columnHeader: t(`assets.columns.purchaseDate`),
      displayType: { displayType: 'date' },
      allowAsConditionSource: true,
    },
    Location: {
      fieldId: 'Location',
      formLabel: t(`assets.fields.Location`),
      columnHeader: t(`assets.columns.location`),
      allowAsConditionSource: true,
    },
    Cost: {
      fieldId: 'Cost',
      formLabel: t(`assets.fields.Cost`),
      columnHeader: t(`assets.columns.cost`),
      allowAsConditionSource: true,
    },
    DepreciationMethod: {
      fieldId: 'DepreciationMethod',
      formLabel: t(`assets.fields.DepreciationMethod`),
      columnHeader: t(`assets.columns.depreciationMethod`),
      allowAsConditionSource: true,
    },
    Assignee: {
      fieldId: 'Assignee',
      formLabel: t(`assets.fields.Assignee`),
      columnHeader: t(`assets.columns.assignee`),
      displayType: {
        displayType: 'users',
        multiple: false,
      },
      allowAsConditionSource: true,
    },
    files: {
      fieldId: 'files',
      formLabel: t(`fields.newFiles`),
      allowTargetConditions: true,
    },
    tags: {
      fieldId: 'tags',
      formLabel: t(`fields.Tags`),
      columnHeader: t(`columns.tags`),
      displayType: {
        displayType: 'tags',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
    departments: {
      fieldId: 'departments',
      formLabel: t(`fields.Departments`),
      columnHeader: t(`columns.departments`),
      displayType: {
        displayType: 'departments',
      },
      allowAsConditionSource: true,
      allowTargetConditions: true,
    },
  } as const satisfies FormConfig;
};
